import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { IDeliverableHeadings } from './IDeliverableHeadings';
import { IStrategyMapDownloadHeadings } from './IStrategyMapDownloadHeadings';


@Injectable()
export class DeliverableService {
  private baseUrl = environment.baseUrl;

  constructor(private http: HttpClient) { }

  getHeadings(strategyId: number): Observable<IDeliverableHeadings> {
    return this.http.get<IDeliverableHeadings>(`${this.baseUrl}/strategies/${strategyId}/deliverables/headings`);
  }

  getTheoryOfActionHeadings(strategyId: number): Observable<IDeliverableHeadings> {
    return this.http.get<IDeliverableHeadings>(`${this.baseUrl}/strategies/${strategyId}/plan/theory-of-action/headings`);
  }

  updateHeadings(strategyId: number, newHeadings: IDeliverableHeadings): Observable<IDeliverableHeadings> {
    return this.http.post<IDeliverableHeadings>(`${this.baseUrl}/strategies/${strategyId}/deliverables/headings`, newHeadings);
  }

  submitDownloadRequest(strategyId: number, headings: IStrategyMapDownloadHeadings): Observable<Object> {
    return this.http.post<Object>(`${this.baseUrl}/strategies/${strategyId}/deliverables/downloads/submit-queuing-request`, headings);
  }
}
